import { GET_VIDEO } from "./VideoType"

export const getVideo = (payload) => {
    return {
        type: GET_VIDEO,
        payload
    }
}